module.exports = __webpack_public_path__ + "img/product_banner_fmcs.f5e31c9b.png";